import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[footer-text-color]'
})
export class FooterTextColorDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer
  ) {
    this.setColor();
  }

  setColor() {
    let text_color = '#ffffff';
    if (localStorage.getItem('footer_color') && localStorage.getItem('footer_color') != '') {
      text_color = localStorage.getItem('footer_color');
    }

    this.renderer.setElementStyle(this.el.nativeElement, 'color', text_color);
  }

}



// WEBPACK FOOTER //
// ./src/directives/footer-text-color/footer-text-color.ts